import React from "react";

function Pre({ load }) {
  return (
    <div
      className={`fixed inset-0 z-[9999] grid place-items-center bg-bg transition-opacity duration-500 ${
        load ? "opacity-100" : "pointer-events-none opacity-0"
      }`}
    >
      <div className="flex flex-col items-center gap-5">
        <div className="relative h-14 w-14">
          <div className="absolute inset-0 rounded-full border-2 border-line" />
          <div className="absolute inset-0 animate-border-spin rounded-full border-2 border-transparent border-t-accent" />
        </div>
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-ink-faint">
          loading
        </p>
      </div>
    </div>
  );
}

export default Pre;
